<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row class="fill-height" justify="start">
        <v-col cols="12">
          <v-card color="#1976d2">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  Характеристика контактов
                </h3>
              </div>
            </v-card-title>
          </v-card>
          <v-card>
            <v-col cols="12">
              <div class="text-center">
                <v-dialog
                  v-model="loading"
                  persistent
                  width="300">
                  <v-card
                    color="primary"
                    dark>
                    <v-card-text>
                      Загружаются данные отчета
                      <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0" />
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
              <v-row align="center" justify="center">
                <BaseControlElement :is-genders-list="true"
                                    :is-places-list="true"
                                    :lowest-date.sync="lowestDate"
                                    :highest-date.sync="highestDate"
                                    :places-selected.sync="placesSelected"
                                    :genders-selected.sync="gendersSelected"
                                    @submitSearch="submitSearch" />
              </v-row>
            </v-col>
            <v-card-title primary-title>
              <div>
                <!--<h3 class="headline mb-0"> Характеристика контактов </h3>-->
                <!--<download-excel v-show="tableData.length>0"-->
                <!--:data   = "tableData"-->
                <!--:fields="json_fields"-->
                <!--name="Характеристика контактов"-->
                <!--&gt;-->
                <!--<v-btn color="green">Скачать отчет                  </v-btn>-->

                <!--</download-excel>-->
              </div>
            </v-card-title>
            <v-card-title>
              <!--<div>-->
              <!--<v-layout align-start-->
              <!--justify-start-->
              <!--column-->
              <!--fill-height>-->
              <!--<span><b>Мужчин</b>: {{ overviewData.men }}</span>-->
              <!--<span><b>Женщин</b>: {{ overviewData.women }}</span>-->
              <!--&lt;!&ndash;<span><b>Возрастные группы</b>: {{overviewData.ages}}</span>&ndash;&gt;-->
              <!--<span><b>Возрастные группы</b>:-->
              <!--<span v-for="(val, key) in overviewData.ages" :key="key"><b>{{ key }}</b>: {{ val }}; <br> </span>-->
              <!--</span>-->

              <v-row class="align-left" justify="space-around">
                <pie-chart v-if="loadedGender"
                           ref="chartDataGender"
                           :chart-data="chartDataGender"
                           :options="chartGenderOptions"
                           title="Распределение по полу"
                           style="height: 300px; width: 300px; padding-right: 50px; padding-top:15px" />

                <pie-chart v-if="loadedAges"
                           ref="chartDataAges"
                           :chart-data="chartDataAges"
                           :options="chartAgesOptions"
                           title="Распределение по возрасту"
                           style="height: 300px; width: 300px; padding-left: 20px" />

                <pie-chart v-if="loadedPlaces"
                           ref="chartDataPlaces"
                           :chart-data="chartDataPlaces"
                           :options="chartPlacesOptions"
                           style="height: 300px; width: 300px"
                           title="Распределение по местам" />
              </v-row>

              <!--</v-layout>-->
              <!--</div>-->
            </v-card-title>

            <ReportTable :data="tableData"
                         :headers="headers"
                         :loading="loading"
                         :additional-headers="additionalHeaders"
                         :is-searchable="false"
                         :table-name="'Характеристика контактов('+lowestDate+' по '+highestDate+')'">
              <template v-slot:info />
              <template v-slot:secondRow>
                <tr>
                  <th colspan="5" />
                  <th :colspan="placesList.length">
                    Количество контактов по местам
                  </th>
                  <!--<th>Всего контактов</th>-->
                </tr>
              </template>
            </ReportTable>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import ReportTable from '../ReportTable'
import BaseControlElement from '../../base/BaseControlElement'
import {authHeader} from '../../../_helpers/auth-header'
// import BaseAutoComplete from '../../base/BaseAutoComplete'
// import {mapState} from 'vuex'
import PieChart from "../../charts/PieChart.vue"

export default {
  name: "ReportCharacteristicsCustomers",
  components: {
    BaseControlElement,
    ReportTable,
    PieChart
  },

  props: {
    report: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lowestDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      highestDate: new Date().toISOString().substr(0, 10),
      loading: false,
      tableData: [],
      headers: [
        {text: '', value: '', align: 'left'},
        {text: 'Код клиента', value: 'full_code', align: 'left', sortable: true},
        {text: 'Пол клиента', value: 'sex', align: 'left', sortable: true},
        {text: 'Дата рождения', value: 'date_of_birth', align: 'left', sortable: true},
        {text: 'Возраст', value: 'age', align: 'left', sortable: true},
        {text: 'Всего контактов', value: 'overall', align: 'left', sortable: true}
      ],
      initHeaders: [
        {text: 'Код клиента', value: 'full_code', align: 'left', sortable: true},
        {text: 'Пол клиента', value: 'sex', align: 'left', sortable: true},
        {text: 'Дата рождения', value: 'date_of_birth', align: 'left', sortable: true},
        {text: 'Возраст', value: 'age', align: 'left', sortable: true},
        {text: 'Всего контактов', value: 'overall', align: 'left', sortable: true}
      ],
      additionalHeaders: [],
      placesList: [],
      overviewData: {},
      placesSelected: [],
      gendersSelected: ['М'],
      genders: [{name: 'М'}, {name: 'Ж'}],
      json_fields: {
        'Код клиента': 'full_code',
        'Пол клиента': 'sex',
        'Дата рождения': 'date_of_birth',
        'Возраст': 'age',
        'Всего контактов': 'overall'

      },
      chartGenderOptions: {
        hoverBorderWidth: 20,
        legend: {
          display: true,
          position: 'left',
          labels: {
            fontSize: 10

          }
        }
      },
      chartAgesOptions: {
        hoverBorderWidth: 20,
        legend: {
          display: true,
          position: 'left',
          labels: {
            fontSize: 10

          }
        }
      },
      chartPlacesOptions: {
        hoverBorderWidth: 20,
        legend: {
          display: true,
          position: 'left',
          labels: {
            fontSize: 10

          }
        }
      },
      chartDataGender: {},
      chartDataAges: {},
      chartDataPlaces: {},
      loaded: false,
      loadedGender: false,
      loadedAges: false,
      loadedPlaces: false,
      colors: [
        {id: 0, hex: "#f12711", disabled: false},
        {id: 1, hex: "#f5af19", disabled: false}
      ]
    }
  },
  // computed: mapState({
  //   places: state => state.tableData.places
  // }),
  methods: {
    // dateLowerUpdated (newVal) {
    //   this.lowestDate = newVal
    // },
    // dateHigherUpdated (newVal) {
    //   this.highestDate = newVal
    // },
    // updatePlaces (newVal) {
    //   this.placesSelected = newVal
    // },
    // updateGenders (newVal) {
    //
    //   this.gendersSelected = newVal
    // },
    submitSearch () {
      let sendVal = Object.assign([], [{text: 'Код клиента', value: 'full_code', align: 'left', sortable: true},
        {text: 'Пол клиента', value: 'sex', align: 'left', sortable: true},
        {text: 'Дата рождения', value: 'date_of_birth', align: 'left', sortable: true},
        {text: 'Возраст', value: 'age', align: 'left', sortable: true},
        {text: 'Всего контактов', value: 'overall', align: 'left', sortable: true}
      ])
      this.headers = Object.assign([], sendVal)
      this.loading = true
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }
      // this.tableData = []
      // this.headers = this.initHeaders
      axios({
        url: this.$store.state.tableData.backend + '/report/customers',
        headers: requestOptions['headers'],
        method: 'post',
        data: {
          lowestDate: this.lowestDate,
          highestDate: this.highestDate,
          placesSelected: this.placesSelected,
          gendersSelected: this.gendersSelected
        }

      }).then((response) => {
        this.loading = false
        this.tableData = response.data.customers
        // let additionalHeaders = []
        let vm = this
        this.placesList = response.data.places_list
        this.overviewData = response.data.cust_overview

        this.loadedGender = !!this.overviewData['genders']
        this.loadedAges = !!this.overviewData['ages']
        this.loadedPlaces = !!this.overviewData['places']

        if (this.loadedGender) {
          this.chartDataGender.labels = this.overviewData['genders']['labels']
          this.chartGenderOptions['legend']['display'] = this.overviewData['genders']['data'].length <= 10
          this.chartDataGender['datasets'] = [
            {
              label: "Пол",
              backgroundColor: ['#1565C0', '#00838F'],
              data: this.overviewData['genders']['data']
            }
          ]
          this.$nextTick(() => {
            this.$refs['chartDataGender'].updateChart()
          })
        }
        if (this.loadedAges) {
          this.chartDataAges.labels = this.overviewData['ages']['labels']
          this.chartAgesOptions['legend']['display'] = this.overviewData['ages']['data'].length <= 10

          this.chartDataAges['datasets'] = [
            {
              label: "Возраст",
              backgroundColor: this.overviewData['ages']['colors'],
              data: this.overviewData['ages']['data']
            }
          ]
          this.$nextTick(() => {
            this.$refs['chartDataAges'].updateChart()
          })
        }
        if (this.loadedPlaces) {
          this.chartDataPlaces.labels = this.overviewData['places']['labels']
          this.chartPlacesOptions['legend']['display'] = this.overviewData['places']['data'].length <= 10
          this.chartDataPlaces['datasets'] = [
            {
              label: "Места",
              backgroundColor: this.overviewData['places']['colors'],
              data: this.overviewData['places']['data']
            }
          ]
          this.$nextTick(() => {

            this.$refs['chartDataPlaces'].updateChart()
          })

        }
        response.data.places_list.forEach(function (v) {
          // vm.additionalHeaders.push({text: v, value: v, align: 'left', sortable: true})
          let exists = false
          vm.headers.forEach(function (val) {
            if (v === val.text) {
              exists = true
            }

          })

          if (!exists) vm.headers.push({text: v, value: v, align: 'left', sortable: true})

        })
        // this.headers.append()
      }).catch((error) => {
        throw new Error(`You can't load the data`)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/pages/ReportCharacteristicsCustomers.vue